import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import { ListItemText, MenuItem, MenuList, Popper } from '@mui/material';
import { FocusTheme } from '@/components/Focus/configs/theme';

export type ChipMenuItemValue = string;

export interface ChipMenuItem {
  label: ReactNode;
  value: ChipMenuItemValue;
  isRemoved?: boolean;
}

interface ScheduleAvailChipMenuProps {
  items: ChipMenuItem[];
  anchorEl: Element | null;
  open: boolean;
}

const ScheduleAvailChipMenu = ({ items, anchorEl, open }: ScheduleAvailChipMenuProps) => {
  return (
    <Popper open={open} anchorEl={anchorEl} placement={'bottom-end'} sx={{ pt: 0.25 }}>
      <StyledMenu>
        {items.map(({ label, value, isRemoved = false }) => {
          return (
            <StyledMenuItem key={value} disabled>
              <StyledListItemText isRemoved={isRemoved}>{label}</StyledListItemText>
            </StyledMenuItem>
          );
        })}
      </StyledMenu>
    </Popper>
  );
};

export default ScheduleAvailChipMenu;

const StyledMenu = styled(MenuList)(({ theme }) => ({
  backgroundColor: (theme as FocusTheme).palette.neutral[60],
  minWidth: 170,
  borderRadius: 8,
  boxShadow: '4px 4px 16px 0px rgba(0, 0, 0, 0.3)',
  maxHeight: 280,
  overflowY: 'auto'
}));

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  gap: theme.spacing(1),

  '&.Mui-disabled': {
    opacity: 1
  }
}));

const StyledListItemText = styled(ListItemText, { shouldForwardProp: (prop) => prop !== 'isRemoved' })<{ isRemoved: boolean }>(
  ({ theme, isRemoved }) => ({
    color: isRemoved ? theme.palette.action.disabled : undefined,
    textDecoration: isRemoved ? 'line-through' : undefined
  })
);
